export default "__VITE_ASSET__Cq8a2G5Y__"